import { useMutation, useQueryClient } from 'react-query';
import { ToastContext } from 'app/components/Context/ToastContext';
import { useContext } from 'react';
import { LikeCommunityIdea } from 'services/apiServices';
import {
  TLikeIdeaResult,
  Errors,
} from 'types/ApiServicesTypes';

export default function useLikeCommunityIdea() {
  const { showAlert } = useContext(ToastContext);
  const queryClient = useQueryClient();

  const mutation = useMutation<TLikeIdeaResult, Errors, number>(
    ['LikeCommunityIdea'],
    ideaId =>
      LikeCommunityIdea(ideaId)
        .then(res => {
          // Invalidate and refetch ideas list and specific idea
          void queryClient.invalidateQueries(['GetCommunityIdeas']);
          void queryClient.invalidateQueries(['GetCommunityIdea', ideaId]);
          return res;
        })
        .catch(err => {
          showAlert!(err.message as string);
          return err;
        }),
  );

  if (mutation.isError && mutation.error) {
    showAlert!(mutation.error.message);
  }

  return mutation;
} 